module.exports = __webpack_public_path__ + "static/assets/7ceba67feea0bc6628e11b4654cff088.svg";